import React from 'react'
export default function LeftAngleArrowIcon({ size = 24, width = size, height = size, fill, secondaryFill, stroke, secondaryStroke, children }) {
  return (<svg width={width} height={height} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="#fff" d="m9.17 12.71 4.24 4.24a1 1 0 1 0 1.42-1.41L11.29 12l3.54-3.54a1 1 0 0 0 0-1.41 1 1 0 0 0-.71-.29 1 1 0 0 0-.71.29l-4.24 4.24a1 1 0 0 0 0 1.42Z"/></svg>)
}
